import { Cols, Col } from 'core/ui';
import * as React from 'react';
import { isString } from '../../../core/lib/ui/ActionButton';

export function DialogIcon({ src, className, style }: { src: string | SvgIcon | undefined, className?: string, style?: React.CSSProperties }) {

	const imgStyle = { ...style, width: 48, height: 48, display: 'inline-block' };

	let Icon: string | SvgIcon = '';
	if (src !== undefined)
		Icon = src;

	return <Cols>
		<Col width='*' className='text-center m-t-md'>
			{src === undefined || isString(src) ? <img style={imgStyle} src={src} className={className} /> : <Icon style={imgStyle} />}
		</Col>
	</Cols>;
}
